<template>
    <div>
        <el-row class="padding10">
            <el-col :span="24" class="align-left padding5 padding-none-v">
                <slot name="area1"></slot>
                <label style="line-height: 35px" class="hidden-md-and-down">{{ T(`instrument_inventory.fact_equipment_nurse`) }}:</label>
                <label style="line-height: 35px" class="hidden-lg-and-up">器械:</label>
                <item-input
                    style="width: 220px"
                    class="hidden-md-and-down"
                    type="remotemultiselect"
                    v-model="equipments"
                    :options="workoption"
                    placeholder="护士签名"
                    :collapseTags="equipments.length > 2"
                ></item-input>
                <item-input style="width: 160px" class="hidden-lg-and-up" type="remotemultiselect" v-model="equipments" :options="workoption" placeholder="护士签名" :collapseTags="true"></item-input>
                <label style="line-height: 35px" class="hidden-md-and-down">&nbsp;巡回护士:</label>
                <label style="line-height: 35px" class="hidden-lg-and-up">&nbsp;巡回:</label>
                <item-input
                    style="width: 220px"
                    class="hidden-md-and-down"
                    type="remotemultiselect"
                    v-model="circuits"
                    :options="workoption"
                    placeholder="巡回护士签名"
                    :collapseTags="circuits.length > 2"
                ></item-input>
                <item-input
                    style="width: 160px"
                    class="hidden-lg-and-up"
                    type="remotemultiselect"
                    v-model="circuits"
                    :options="workoption"
                    placeholder="巡回护士签名"
                    :collapseTags="true"
                ></item-input>
                <el-button
                    v-if="rowChanges.length > 0 || equipments.toString() !== equipments_bak.toString() || circuits.toString() !== circuits_bak.toString()"
                    type="warning"
                    size="mini"
                    @click="SaveChanges"
                    ><i class="el-icon-loading" v-if="!finished"></i>保存</el-button
                >
                <el-link
                    v-if="rowChanges.length > 0 || equipments.toString() !== equipments_bak.toString() || circuits.toString() !== circuits_bak.toString()"
                    type="warning"
                    size="mini"
                    @click="clearChanges"
                >
                    撤销
                </el-link>
                <!-- <el-button type="primary" size="mini" @click="loadDamagedView">损耗记录</el-button> -->
            </el-col>
            <slot name="area2"></slot>
        </el-row>

        <el-table ref="cus-table" class="el-table--scrollable-y" :data="tableData" header-align="center" border :row-key="catKeyVal">
            <!-- <el-table-column width="100" v-if="package_style=='separated'" :span-method="objectSpanMethod"
      prop="group_name"
      label="分组">
    </el-table-column> -->
            <el-table-column prop="item_name" label="项目名称" header-align="center"> </el-table-column>
            <el-table-column :prop="item.prop" v-for="item in columnSetting" :key="item.prop + (item.locked ? '_1' : '_0')" :width="columnWidth" header-align="center">
                <span slot="header">
                    <span>{{ item.stage_name }}</span>
                    <span>
                        <span class="iconfont el-icon-plus fg-primary cus-button" v-if="!item.allow_edit" @click="loadAppendSuppliesView(item)" title="添加耗材"></span>
                        <span class="el-icon-refresh-right fg-primary cus-button" v-else @click="AutoComplete(item.id)"></span>
                    </span>
                </span>
                <template slot-scope="scope">
                    <span v-if="item.locked"></span>
                    <item-input
                        class="inventory-datetime"
                        v-else-if="scope.$index == 0 && (!showCountStageTime || showCountStageTime == `1`)"
                        type="hhdatetime"
                        v-model="scope.row[item.prop]"
                        datetimeFormate="yyyy/MM/dd HH:mm:ss"
                        showFormate="MM-dd HH:mm"
                        @input="RowChange({ index: scope.$index, row: scope.row, prop: item.prop, column: item })"
                    >
                    </item-input>
                    <span v-else-if="!item.allow_edit && scope.row[item.prop] == '-1'"></span>
                    <el-row v-else>
                        <el-col :span="14">
                            <item-input
                                type="integer"
                                v-model="scope.row[item.prop]"
                                @activeRow="setActiveRow(arguments)"
                                :class="{ 'un-eq': scope.row[`un_eq_${item.prop}`] != scope.row[item.prop] }"
                                :readonly="(!checkboxs[scope.$index] && item.need_check && item.prop == checkColumn) || (item.prop != checkColumn && !isedit)"
                                @input="RowChange({ index: scope.$index, row: scope.row, prop: item.prop, column: item })"
                            ></item-input>
                        </el-col>
                        <el-col :span="4" class="padding5">
                            <item-input type="checkbox" v-model="checkboxs[scope.$index]" v-if="item.prop == checkColumn"></item-input>
                        </el-col>
                        <el-col :span="6">
                            <span v-if="scope.row[`damaged_${item.prop}`]" class="cus-button is-circle bg-danger" style="float: right; width: 24px">
                                <el-popover
                                    placement="top-start"
                                    :title="scope.row[`damaged_${item.prop}`].stuff_destination"
                                    width="200"
                                    trigger="hover"
                                    :content="scope.row[`damaged_${item.prop}`].remark"
                                >
                                    <span slot="reference">{{ scope.row[`damaged_${item.prop}`].amount }} </span>
                                </el-popover>
                            </span>
                        </el-col>
                    </el-row>
                    <!-- <span v-else>--</span> -->
                </template>
            </el-table-column>
            <el-table-column prop="oper" width="60" label="操作" header-align="center">
                <template slot-scope="scope">
                    <span v-if="scope.$index == 0 && (!showCountStageTime || showCountStageTime == `1`)"></span>
                    <el-button type="danger" plain size="mini" v-else @click="removeItem({ index: scope.$index, row: scope.row })">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 添加耗材 -->
        <form-dialog
            class="form-table-h380"
            title="添加耗材"
            :visible.sync="suppliesIn.dialogFormVisible"
            :columns="appendSuppliesColumns"
            :data="suppliesIn.data"
            width="40%"
            @confirm="appendSuppliesConfirm"
        >
            <!-- <cus-form ref="form-appendSupplies"  :columns="appendSuppliesColumns" @extrabutton-click="ExtraButtonClick"
    @confirm="appendSupplies"></cus-form> -->
        </form-dialog>
        <!-- 破损记录 -->
        <el-dialog class="form-table-h380" title="破损记录" :visible.sync="damagedView.dialogFormVisible" :close-on-click-modal="false" width="95%">
            <cus-form ref="form-damaged" :data="damagedView" :columns="damagedViewColumns" @extrabutton-click="ExtraButtonClick"></cus-form>
        </el-dialog>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
const TIME_ROW_ID = `_m_t1`
export default {
    name: `ItemConsumable`,
    props: {
        id: { type: String | Number },
        workflow_name: { type: String },
        dic_worker_circuit: { type: Array },
        dic_worker_inst: { type: Array },
        enum_count_type: { type: String | Number },
        biz_surgery_info_id: { type: String | Number }
    },
    inject: [`reload`],
    data() {
        return {
            isWorkerByDuty: this.$root.IsWorkerByDuty,
            mode: undefined,
            modes: [],
            columnSetting: [],
            allowinit: true,
            tableData: [],
            instrument_count: 0, // 器械种类数  用于显示合并行
            supplies_count: 0, // 耗材种类数
            rowChanges: [],
            tableData_bak: [],
            surgeryId: this.biz_surgery_info_id,
            instruments_count_by_group: {},
            enum_package: [],
            instore_style: `hand`,
            package_style: this.$root[`PackageCountingType`], // separated  combin
            finished: true,
            equipments: this.dic_worker_inst || [],
            equipments_bak: this.dic_worker_inst || [],
            circuits: this.dic_worker_circuit || [],
            circuits_bak: this.dic_worker_circuit || [],
            checkColumn: undefined,
            checkboxs: [],
            stage: 0,
            suppliesIn: {
                dialogFormVisible: false,
                data: {
                    stage: 0,
                    dic_supplies: undefined,
                    amount: 0
                }
            },
            damagedView: {
                dialogFormVisible: false,
                damaged: []
            },
            surgeryinfo: {},
            showCountStageTime: this.$root.ShowCountStageTime
        }
    },
    created() {
        this.$nextTick(function() {
            this.setTableheight()
        })
    },
    mounted() {
        if (this.surgeryId) {
            this.loadColumnSetting().then(() => {
                this.loadCountings()
            })
        }
    },
    computed: {
        ...mapGetters([`permissions`, `sysuser/workers_by_duty`, `sysuser/workers_by_dutyNew`, `screenHeight`, `screenWidth`, `sys_enums`, `active_ward`]),
        isedit() {
            return this.permissions && this.permissions.findIndex(item => item.no === `inventory_edit`) != -1
        },
        tableHeight() {
            return this.screenHeight - 210
        },
        worker() {
            if (this.isWorkerByDuty == `0`) {
                return this[`sysuser/workers_by_duty`]
            } else if (this.isWorkerByDuty == `1`) {
                return this[`sysuser/workers_by_dutyNew`]
            }
        },
        workoption() {
            return q => {
                let works = this.isWorkerByDuty == `0` ? this.worker[`护士`] || [] : this.worker[`巡回护士`] || []
                if (q && q.keyword) {
                    return works.filter(d => {
                        return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                    })
                } else {
                    return works
                }
            }
        },
        columnWidth() {
            if (this.screenWidth > 1024) {
                return 140
            }
            return 110
        },
        appendSuppliesColumns() {
            return [{
                type: `select`,
                prop: `stage`,
                label: `节点`,
                options: this.columnSetting,
                readonly: true
            }, {
                type: `remotemultiselect`,
                prop: `dic_supplies`,
                label: `耗材`,
                showCount: 10,
                collapseTags: false,
                options: `/api/AcisSystem/Supplies/Search`,
                config: { popperAppendToBody: true }
            }, {
                type: `integer`,
                prop: `amount`,
                width: `60`,
                label: `数量`,
                default: 1
            }]
        },
        itemd() {
            return _.tail(this.tableData).map(d => {
                return {
                    value: `${d.group_id || 0}_${d.item_id}`,
                    label: d.item_name,
                    // group:d.group_name,
                    item_id: d.item_id,
                    group_id: d.group_id
                }
            })
        },
        damagedViewColumns() {
            return [{
                type: `groupselect`,
                prop: `itemid`,
                label: `物品`,
                options: this.itemd,
                colspan: 4,
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
            }, {
                type: `select`,
                prop: `enum_count_stage`,
                label: `节点`,
                options: this.columnSetting,
                colspan: 4,
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
            }, {
                type: `number`,
                prop: `amount`,
                label: `数量`,
                colspan: 4,
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                default: 1
            }, {
                type: `select`,
                prop: `enum_stuff_destination`,
                label: `去向`,
                options: this.sys_enums.Enum_StuffDestination,
                colspan: 4,
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                default: 1
            }, {
                type: `string`,
                prop: `remark`,
                label: `备注`,
                colspan: 4
            }, {
                type: `buttongroup`,
                prop: `oper`,
                label: ``,
                options: [{
                    // class:"is-plain",
                    label: `添加`,
                    type: `primary`,
                    emit: `appendDamaged`,
                    permission: `default`
                }],
                colspan: 4
            }, {
                type: `table2`,
                prop: `damaged`,
                label: { content: `耗损记录`, position: `top` },
                options: [{
                    type: `string`,
                    prop: `id`,
                    label: `编号`
                }, {
                    type: `string`,
                    prop: `name`,
                    label: `名称`,
                    isListable: true
                }, {
                    type: `select`,
                    prop: `biz_count_stage_id`,
                    label: `节点`,
                    isListable: true,
                    options: this.columnSetting
                }, {
                    type: `string`,
                    prop: `amount`,
                    label: `数量`,
                    isListable: true
                }, {
                    type: `select`,
                    prop: `stuff_destination`,
                    label: `去向`,
                    isListable: true,
                    options: this.sys_enums.Enum_StuffDestination
                }, {
                    type: `string`,
                    prop: `remark`,
                    label: `备注`,
                    isListable: true
                }, {
                    type: `buttongroup`,
                    prop: `oper`,
                    label: `操作`,
                    width: `100`,
                    readonly: false,
                    isListable: true,
                    options: [{
                        class: `is-plain`,
                        label: `删除`,
                        type: `danger`,
                        emit: `deleteDamaged`,
                        permission: `default`,
                        isListable: true
                    }]
                }],
                colspan: 24
            }]
        }
    },
    methods: {
        catKeyVal(item) {
            return `${item.item_id}`
        },
        setTableheight() {
            let el = this.$refs[`cus-table`].$el.querySelector(`.el-table__body-wrapper`)
            let elFixed = this.$refs[`cus-table`].$el.querySelector(`.el-table__fixed-body-wrapper`)
            let elHeader = this.$refs[`cus-table`].$el.querySelector(`.el-table__header-wrapper`)
            el.style.height = `${this.tableHeight - elHeader.offsetHeight - 5}px`
            elFixed && elFixed.style && (elFixed.style.height = `${this.tableHeight - elHeader.offsetHeight - 5}px`)
        },
        loadColumnSetting() {
            let that = this
            return new Promise((resolve, reject) => {
                let req = this.myaxios.get(`/api/Nursing/CountingFlow/GetFlow?surgeryId=${this.surgeryId}`)
                req.then(data => {
                    let r = _.find(data, { id: this.id })
                    this.equipments_bak = this.equipments = r.dic_worker_inst || []
                    this.circuits_bak = this.circuits = r.dic_worker_circuit || []
                    this.columnSetting = _.map(_.orderBy(r.count_stage, `display_order`), (d, index) => {
                        d.prop = `c${d.dic_event_id}`
                        d.label = d.stage_name
                        d.value = d.id
                        if (index > 0 && this.$moment(d.modify_date).format(`YYYYMMDD`) == `19010101`) {
                            d.locked = true
                        } else if (that.showCountStageTime == `0` || index == 0 || that.$moment(d.modify_date).isAfter(r.count_stage[index - 1].modify_date)) {
                            d.locked = false
                        } else {
                            d.locked = true
                        }
                        return d
                    })
                    resolve()
                }).catch(e => reject(e))
            })
        },
        initCoutings() {
            let req1 = this.myaxios.get(`/api/AcisSystem/SuppliesCountingOperatingWardConfig/Get`)
            let req2 = this.myaxios.post(`/api/Nursing/CountingFlow/UpdateStageTime?stageId=${this.columnSetting[0].value}&dateTime=${this.$moment().format(`YYYY/MM/DD HH:mm:ss`)}`)
            this.myaxios.all(req1, req2).then(([data, data2]) => {
                let preloaditems = _.filter(data, d => `ow_${d.dic_operating_ward_id}` == this.active_ward.value)
                if (preloaditems.length > 0) {
                    let req = this.myaxios.post(`/api/Nursing/CountingSupply/SaveData`, _.map(preloaditems, (sp, index) => {
                        return {
                            'dic_supply_id': sp.dic_supplies_id,
                            'supply_alias': sp.supplies_model.alias,
                            'amount': 0,
                            'display_order': index + 1,
                            'biz_count_stage_id': this.columnSetting[0].value
                        }
                    }))
                    req.then(() => {
                        this.loadColumnSetting().then(() => {
                            this.loadCountings()
                        })
                    })
                } else {
                    this.allowinit = false
                    this.$message.warning(`暂未配置耗材清点项目`)
                    this.loadColumnSetting().then(() => {
                        this.loadCountings()
                    })
                }
            })
        },
        loadCountings() {
            let req = this.myaxios.post(`api/Nursing/CountingSupply/GetStagesData`, _.map(this.columnSetting, d => d.id))
            let req2 = this.loadDamaged()
            this.myaxios.all(req, req2).then(([data, damaged]) => {
                if (data.length == 0 && this.allowinit) {
                    this.initCoutings()
                    return
                }
                let modifyTime = { item_name: `时间`, item_id: TIME_ROW_ID, item_type: `时间` }
                _.forEach(this.columnSetting, (c, index) => {
                    modifyTime[c.prop] = this.$moment(c.modify_date).format(`YYYY/MM/DD HH:mm:ss`)
                })
                let ct = _.map(data, (d, index) => {
                    d.row_index = index + 1
                    d.item_id = d.supply_id // supply_alias
                    d.item_name = d.supply_alias
                    _.forEach(this.columnSetting, (c, index) => {
                        d[c.prop] = d.amount[index]
                        d[`un_eq_${c.prop}`] = d.amount[index]
                        // let dmgs  =_.filter(damaged,{dic_instrument_id:d.item_id,biz_count_stage_id:c.id})
                        // if(dmgs.length>0){
                        //   let dmg={
                        //     amount:_.sumBy(dmgs, d=>d.amount),
                        //     stuff_destination:_.map(dmgs,d=>`${d.stuff_destination}(${d.amount})`).toString(),
                        //     remark:_.map(dmgs,d=>d.remark == null?'无':`${d.stuff_destination}:${d.remark}`).toString(),
                        //   }
                        //   d[`damaged_${c.prop}`] =  dmg
                        // }
                        d[`need_check_${c.prop}`] = c.need_check
                    })
                    return d
                })
                if (ct.length > 0) {
                    ct.splice(0, 0, modifyTime)
                }
                if (this.showCountStageTime == `0`) {
                    ct = ct.filter(d => { return d.item_name != `时间` })
                }
                this.tableData_bak = _.cloneDeep(ct)
                this.tableData = ct
            })
        },
        loadAppendSuppliesView(col) {
            this.suppliesIn.data.stage = col.value
            this.suppliesIn.data.amount = 0
            this.suppliesIn.dialogFormVisible = true
        },
        appendSuppliesConfirm(row) {
            let that = this
            let datas = _.reduce(
                row.dic_supplies,
                (result, v, index) => {
                    let rowOrder = _.find(that.tableData, { supply_id: v.value })
                    let r = {
                        amount: row.amount,
                        biz_count_stage_id: row.stage,
                        dic_supply_id: v.value,
                        display_order: rowOrder && rowOrder.display_order || (that.tableData.length) + 1,
                        supply_alias: v.alias
                    }
                    result.push(r)
                    return result
                },
                []
            )

            let req = this.myaxios.post(`/api/Nursing/CountingSupply/SaveData`, datas)

            let req2
            let cs = _.find(this.columnSetting, { id: row.stage })
            let timeRow = _.find(this.tableData, { item_id: TIME_ROW_ID })
            let now = this.$moment().format(`YYYY/MM/DD HH:mm:ss`)
            if (!timeRow || timeRow[cs.prop] == `1901/01/01 00:00:00` || this.showCountStageTime == `0`) {
                req2 = this.myaxios.post(`/api/Nursing/CountingFlow/UpdateStageTime?stageId=${row.stage}&dateTime=${now}`)
            } else {
                req2 = Promise.resolve(``)
            }
            this.myaxios.all(req, req2).then(() => {
                this.loadColumnSetting().then(() => {
                    this.loadCountings()
                })
                this.suppliesIn.dialogFormVisible = false
            })
        },
        inStoreByScan(row) {
            let that = this
            let fiv = _.findIndex(that.packageIn.packages, { internal_code: row.internal_code })
            let task = new Promise((resolve, reject) => {
                if (fiv > -1) {
                    this.$confirm(`是否删除?`, `提示`, {
                        confirmButtonText: `确定`,
                        cancelButtonText: `取消`,
                        type: `warning`,
                        closeOnClickModal: false
                    }).then(() => {
                        resolve()
                    }).catch((e) => {
                        reject()
                    })
                } else {
                    resolve()
                }
            })
            task.then(() => {
                let req = that.myaxios.post(`/api/Nursing/CountingContent/${this.package_style == `separated` ? `ScanPackageSeparated` : `ScanPackage`}?code=${row.internal_code}&surgeryId=${this.surgeryId}&stage=${this.stage}&wardId=${this.active_ward.origion}`)
                req.then(data => {
                    if (data && fiv == -1) {
                        that.packageIn.packages.push(data)
                        that.rowClick({ row: data })
                        that.loadCountings()
                    } else {
                        that.packageIn.packages.splice(fiv, 1)
                        that.loadCountings()
                        that.packageIn.instruments = []
                    }
                }).catch(e => {
                    console.log(e)
                })
            }).catch(e => {})
        },
        ExtraButtonClick(target) {
            if (target.emit == `rowClick`) return
            this[target.emit](target)
        },
        ExtraButtonClick2(target) {
            this[target.emit](target)
        },
        AutoComplete(stage) { // 刷新列
            let that = this
            let cr = _.find(this.columnSetting, { id: stage })
            this.$set(cr, `locked`, false)
            this.checkColumn = cr.prop
            this.tableData = this.tableData.map((d, index) => {
                let r = { ...d }
                r[cr.prop] = 0
                if (index == 0 && (!this.showCountStageTime || this.showCountStageTime == `1`)) {
                    r[cr.prop] = this.$moment().format(`YYYY/MM/DD HH:mm:ss`)
                } else if (cr.calculate_relation) {
                    _.forEach(cr.calculate_relation.split(`,`), i => {
                        let rnum = parseInt(r[`c${i}`] && r[`c${i}`] == -1 ? 0 : r[`c${i}`])
                        r[cr.prop] += rnum || 0
                    })
                }
                r[`un_eq_${cr.prop}`] = r[cr.prop]
                if (!that.showCountStageTime || that.showCountStageTime == `1`) {
                    r.display_order = index
                } else {
                    r.display_order = index + 1
                }
                r[`need_check_${cr.prop}`] = cr.need_check
                this.RowChange({ index, row: r, prop: cr.prop })
                return r
            })
        },
        RowChange({ index, row, prop }) { // 监听更改的行
            let oldr = this.tableData_bak[index]
            let r = { item_id: oldr.item_id, item_name: oldr.item_name, group_id: oldr.group_id, row_index: index + 1, display_order: row.display_order || 0 }
            let i = _.findIndex(this.rowChanges, { item_id: oldr.item_id, group_id: oldr.group_id })
            if ((oldr && oldr[prop]) == row[prop] && this.rowChanges && this.rowChanges[i]) {
                this.$delete(this.rowChanges[i], prop)
                if (Object.getOwnPropertyNames(this.rowChanges[i]).length == 3) {
                    this.rowChanges.splice(i, 1)
                }
            } else {
                r[prop] = row[prop]
                if (i > -1) {
                    this.rowChanges[i][prop] = row[prop]
                } else {
                    this.rowChanges.push(r)
                }
            }
        },
        setActiveRow(args) {
            let _this = this
            let rowIndex = args[0]
            let cellIndex = args[1]
            let direction = args[2]
            _this.$nextTick(() => {
                let activeRow = this.$refs[`cus-table`].$el.querySelector(`.el-table__body-wrapper`).querySelectorAll(`.el-table__row`)[rowIndex]
                if (activeRow && activeRow.children[cellIndex]) {
                    let activeInput = activeRow.children[cellIndex].getElementsByTagName(`input`)[0]
                    let celllenth = activeRow.cells.length
                    let rowlen = activeRow.parentElement.nodeName == `TBODY` && activeRow.parentElement.children.length // 行数
                    let whileCount = 0
                    while (!activeInput && whileCount <= rowlen) {
                        switch (direction) {
                        case `up`:
                            rowIndex = rowIndex - 1
                            if (rowIndex < 0) { rowIndex = rowlen - 1 }
                            break
                        case `down`:
                            rowIndex = rowIndex + 1
                            if (rowIndex === rowlen) { rowIndex = 0 }
                            break
                        case `left`:
                            cellIndex = cellIndex - 1
                            if (cellIndex < 0) { cellIndex = celllenth - 1 }
                            break
                        case `right`:
                            cellIndex = cellIndex + 1
                            if (cellIndex === celllenth) { cellIndex = 0 }
                            break
                        case `enter`:
                            cellIndex = cellIndex + 1
                            if (cellIndex === celllenth) {
                                cellIndex = 0
                                rowIndex += 1
                                if (rowIndex === rowlen) { rowIndex = 0 }
                                activeRow = this.$refs[`cus-table`].$el.querySelector(`.el-table__body-wrapper`).querySelectorAll(`.el-table__row`)[rowIndex]
                            }
                            break
                        }
                        activeInput = activeRow && activeRow.children[cellIndex] && activeRow.children[cellIndex].getElementsByTagName(`input`)[0]
                        whileCount += 1
                    }
                    activeInput && activeInput.focus()
                    activeInput && activeInput.select()
                }
            })
        },
        clearChanges() {
            this.loadColumnSetting().then(() => {
                this.loadCountings()
            })
            this.finished = true
            this.rowChanges = []
            this.checkColumn = undefined
            this.equipments = this.equipments_bak
            this.circuits = this.circuits_bak
        },
        SaveChanges() { //  保存用户更改，成功刷新数据，失败不刷新
            let that = this
            if (that.finished) {
                let step = new Promise((resolve, reject) => {
                    if (
                        this.checkColumn != undefined &&
                        this.tableData.length - 1 >
                            _.filter(this.checkboxs, d => {
                                return d
                            }).length
                    ) {
                        if (this.tableData[0][`need_check_${this.checkColumn}`]) {
                            this.$message.error(`核查数据未全部确认，请勾选确认`)
                            reject()
                        } else {
                            this.$confirm(`未全部确认, 是否继续?`, `提示`, {
                                confirmButtonText: `确定`,
                                cancelButtonText: `取消`,
                                type: `warning`,
                                closeOnClickModal: false
                            })
                                .then(() => {
                                    resolve()
                                })
                                .catch(e => {
                                    reject()
                                })
                        }
                    } else {
                        resolve()
                    }
                })
                step.then(() => {
                    that.finished = false
                    let timeRow = _.find(that.tableData, { item_id: TIME_ROW_ID })
                    let now = that.$moment().format(`YYYY/MM/DD HH:mm:ss`)
                    let reqs = []
                    // 验证时间
                    let prevT
                    let msg
                    let cs = _.filter(that.columnSetting, d => !d.locked)
                    _.forEach(cs, c => {
                        if (!c.locked) {
                            if (timeRow && timeRow[c.prop]) {
                                if (prevT && !that.$moment(timeRow[c.prop]).isAfter(timeRow[prevT.prop]) && timeRow[c.prop] != timeRow[prevT.prop]) {
                                    msg = `${prevT.stage_name}  的时间不允许超过 ${c.stage_name}`
                                }
                                prevT = c
                                reqs.push(this.myaxios.post(`/api/Nursing/CountingFlow/UpdateStageTime?stageId=${c.id}&dateTime=${timeRow[c.prop]}`))
                            } else if (that.showCountStageTime == `0`) {
                                reqs.push(this.myaxios.post(`/api/Nursing/CountingFlow/UpdateStageTime?stageId=${c.id}&dateTime=${now}`))
                            }
                        }
                    })

                    let models = _.reduce(_.filter(that.rowChanges, row => { return row.item_id != TIME_ROW_ID }), function(result, row, index) {
                        _.forEach(cs, c => {
                            if (row[c.prop] != undefined) {
                                result.push({
                                    'dic_supply_id': 0,
                                    // eslint-disable-next-line no-dupe-keys
                                    'dic_supply_id': row.item_id,
                                    'supply_alias': row.item_name, // row.item_id,
                                    'amount': row[c.prop],
                                    'biz_count_stage_id': c.id,
                                    'display_order': row.display_order
                                })
                            }
                        })
                        return result
                    }, [])
                    if (msg) {
                        that.$message.warning(msg)
                        that.finished = true
                        return
                    }
                    reqs.push(this.myaxios.post(`/api/Nursing/CountingSupply/SaveData`, models))
                    reqs.push(this.myaxios.put(`/api/Nursing/CountingFlow/EditFlow`, {
                        'id': this.id,
                        'dic_worker_inst_id': this.equipments.map(c => c.value),
                        'dic_worker_circuit_id': this.circuits.map(c => c.value)
                    }))
                    this.myaxios.all(...reqs).then(() => {
                        that.finished = true
                        that.rowChanges = []
                        that.checkboxs = []
                        this.loadColumnSetting().then(() => {
                            this.loadCountings()
                        })
                        this.checkColumn = undefined
                    }).catch((e) => {
                        that.finished = true
                    })
                })
            }
        },
        removeItem({ row, index }) {
            this.$confirm(`此操作将永久删除该记录, 是否继续?`, `提示`, {
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`,
                closeOnClickModal: false
            }).then(() => {
                let req = this.myaxios.delete(`/api/Nursing/CountingSupply/DeleteData?flowId=${this.id}&surgeryInfoId=${this.biz_surgery_info_id}&supplyId=${row.supply_id}&alias=${row.supply_alias}`)
                req.then(() => {
                    this.$message.success(`删除成功`)
                    this.loadCountings()
                }).catch(e => { console.log(e) })
            }).catch((e) => {})
        },
        loadDamaged() {
            return new Promise((resolve, reject) => {
                let req = this.myaxios.get(`/api/Nursing/DamagedInstrument/Get?flowId=${this.id}`)
                req.then(data => {
                    resolve(data)
                }).catch(e => {
                    console.log(e)
                    resolve([])
                })
            })
        },
        loadDamagedView() {
            this.loadDamaged().then((data) => {
                this.damagedView.damaged = data
                this.damagedView.dialogFormVisible = true
            })
        },
        appendDamaged({ formdata }) {
            let item = _.find(this.itemd, { value: formdata.itemid })
            let req = this.myaxios.post(`/api/Nursing/DamagedInstrument/Post`, {
                'biz_count_instrument_id': this.id,
                'amount': formdata.amount,
                'enum_stuff_destination': formdata.enum_stuff_destination,
                'remark': formdata.remark,
                'biz_use_package_id': item.group_id,
                'dic_instrument_id': item.item_id,
                'name': item.label,
                'biz_count_stage_id': formdata.enum_count_stage
            })
            req.then(data => {
                this.loadDamagedView()
                this.loadCountings()
            }).catch(e => {
                console.log(e)
            })
        },
        deleteDamaged({ row, index }) {
            let that = this
            let req = this.myaxios.delete(`/api/Nursing/DamagedInstrument/Delete/${row.id}`)
            req.then(data => {
                that.damagedView.damaged.splice(index, 1)
                this.loadCountings()
                that.$message.success(`删除成功`)
            }).catch(e => {
                console.log(e)
            })
        }
    },
    watch: {
        // $route: function(newUrl, oldUrl) {
        //   this.surgeryId=newUrl.query.surgery_id
        //   this.loadColumnSetting().then(()=>{
        //     this.loadCountings()
        //   }).catch(()=>{})
        //   this.rowChanges=[]
        // },
        // mode: function(newval, oldval) {
        //   if(oldval!==undefined&&newval!==undefined){
        //     this.$confirm('切换模式后当前模式下数据会被清空, 是否继续?', '提示', {
        //       confirmButtonText: '确定',
        //       cancelButtonText: '取消',
        //       type: 'danger',
        //       closeOnClickModal:false
        //     }).then(() => {
        //       let req1 =this.myaxios.delete(`/api/Nursing/Counting/ClearCounting?surgeryId=${this.surgeryId}`)
        //       req1.then(()=>{
        //         let newcolumnsetting =_.find(this.modes,{value:newval}).columns
        //         let req4 = this.myaxios.post(`/api/Nursing/Counting/SubmitWorkflow?surgeryId=${this.surgeryId}&workflow=${newval}&columnCount=${newcolumnsetting.length}`)
        //         req4.then(data=>{
        //           this.loadCountings()
        //           this.columnSetting = newcolumnsetting
        //         })
        //       })

        //     }).catch(()=>{
        //       if(this.reload){
        //         this.reload()
        //       }
        //     })
        //   }
        // },
    }
}
</script>
<style scoped>
.no-surgery {
    line-height: 600px;
    font-size: 24px;
    opacity: 0.5;
}
</style>
<style lang="less">
.un-eq input {
    color: red !important;
}
.inventory-datetime {
    &.el-input--suffix .el-input__inner {
        padding-right: 5px !important;
    }
    &.el-input--prefix .el-input__inner {
        padding-left: 5px !important;
    }
    .el-input__suffix {
        display: none;
    }
    .el-input__prefix {
        display: none;
    }
    input {
        text-align: center;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Surgery/Inventory/ItemConsumable.vue